import { PRESUPUESTADOR_SET_ERROR_AMOUNT } from '../constants'

export function setErrorAmount(bolean) {
    return dispatch => {
        dispatch({
            type: PRESUPUESTADOR_SET_ERROR_AMOUNT,
            data: bolean
        })
    }
}
